import validate from "/vercel/path0/node_modules/.pnpm/nuxt@3.13.2_@parcel+watcher@2.4.1_@types+node@22.8.4_encoding@0.1.13_eslint@9.13.0_jiti@2.5.1_fibhreukqpnspumyfkutbw6lfi/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/vercel/path0/node_modules/.pnpm/nuxt@3.13.2_@parcel+watcher@2.4.1_@types+node@22.8.4_encoding@0.1.13_eslint@9.13.0_jiti@2.5.1_fibhreukqpnspumyfkutbw6lfi/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}